import React, { useEffect, useRef } from "react";
import * as styles from "./Signature.module.scss";
import classNames from "classnames";
import PropTypes from "prop-types";
import Icon from "../Icon";
import SignaturePad from "react-signature-pad-wrapper";

const Signature = ({ label, initialValue, onUpdate, field, form, className }) => {
	const signaturePadRef = useRef();
	let SignatureClassName = classNames({
		[styles["signature"]]: true,
		[className]: !!className,
	});

	useEffect(() => {
		const signaturePad = signaturePadRef.current.signaturePad;
		const canvas = signaturePad.canvas;

		if (initialValue) {
			const ctx = canvas.getContext("2d");
			const img = new Image();
			img.src = initialValue;
			img.onload = () => {
				ctx.drawImage(img, 0, 0, canvas.getBoundingClientRect().width, canvas.getBoundingClientRect().height);
			};
		}

		const updateHandler = () => {
			form.setFieldValue(field.name, canvas.toDataURL());
			if (onUpdate && typeof onUpdate === "function") {
				const base64 = canvas.toDataURL();
				onUpdate(base64);
			}
		};

		signaturePad.addEventListener("endStroke", updateHandler, false);
	}, [initialValue, signaturePadRef]);

	return (
		<div className={SignatureClassName}>
			<Icon
				size={24}
				icon={"bin-outline"}
				className={styles["clear-signature"]}
				onClick={() => {
					signaturePadRef.current.clear();
					if (onUpdate && typeof onUpdate === "function") {
						onUpdate("");
					}
				}}
			/>
			<SignaturePad ref={signaturePadRef} redrawOnResize={false} options={{ penColor: "rgb(0, 153, 168)" }} />
			<div className={styles["signature-label"]}>
				<Icon size={24} icon={"pen"} className={styles["pen"]} />
				{label}
			</div>
		</div>
	);
};

Signature.propTypes = {
	label: PropTypes.string,
	onUpdate: PropTypes.func,
	initialValue: PropTypes.string,
	className: PropTypes.string,
};

export default Signature;
